// frontend/src/router/routes/authRoutes.tsx
// TEMPORARY: Using inline PublicRoute until we create the separate component
import { Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import LoadingSpinner from "@/components/LoadingSpinner";
import AuthLayout from "@/components/Layout/AuthLayout";
import LoginForm from "@/components/auth/LoginForm";
import RegisterSelection from "@/components/auth/RegisterSelection";
import CustomerRegisterForm from "@/components/auth/CustomerRegisterForm";
import PartnerRegisterForm from "@/components/auth/PartnerRegisterForm";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import EmailVerificationForm from "@/components/auth/EmailVerificationForm";

// TEMPORARY: Inline PublicRoute component (until we create the separate file)
const PublicRoute: React.FC<{
  children: React.ReactNode;
  redirectTo?: string;
}> = ({ children, redirectTo = "/dashboard" }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <AuthLayout>{children}</AuthLayout>;
};

export const authRoutes = [
  <Route
    key="login"
    path="/login"
    element={
      <PublicRoute>
        <LoginForm />
      </PublicRoute>
    }
  />,
  <Route
    key="register"
    path="/register"
    element={
      <PublicRoute>
        <RegisterSelection />
      </PublicRoute>
    }
  />,
  <Route
    key="register-customer"
    path="/register/customer"
    element={
      <PublicRoute>
        <CustomerRegisterForm />
      </PublicRoute>
    }
  />,
  <Route
    key="register-partner"
    path="/register/partner"
    element={
      <PublicRoute>
        <PartnerRegisterForm />
      </PublicRoute>
    }
  />,
  <Route
    key="forgot-password"
    path="/forgot-password"
    element={
      <PublicRoute>
        <ForgotPasswordForm />
      </PublicRoute>
    }
  />,
  <Route
    key="reset-password"
    path="/reset-password"
    element={
      <PublicRoute>
        <ResetPasswordForm />
      </PublicRoute>
    }
  />,
  <Route
    key="verify-email"
    path="/verify-email"
    element={
      <PublicRoute>
        <EmailVerificationForm />
      </PublicRoute>
    }
  />,
];